import React from "react";
import Layout from "./shared/Layout";
import { Link } from "react-router-dom";
import classes from './assets/css/Home.module.css';

const Home = () => {
  return (
    <Layout>
      <div className={`${classes.home_wrapper} py-5`}>
        <h1 className={`${classes.greetings} mb-0 me-5 text-center`}>Hello</h1>
        <div className="home-content">
          <h2 className={`dark-text ${classes.intro}`}>
            I'm Joshua, I Build Things For The Web.
          </h2>
          <p className={classes.title}>Front End Developer / Web Developer</p>
        </div>
        <div className="home-link text-center mt-4">
          <Link className="btn-blue me-2 py-2 px-3 rounded-pill" to="/projects">
            MY PROJECTS
          </Link>
          <Link className="btn-transparent ms-2 py-2 px-3 rounded-pill" to="/about">
            MORE ABOUT ME
          </Link>
        </div>
      </div>
    </Layout>
  );
};

export default Home;
